module.exports = __webpack_public_path__ + "static/media/logo.8a7735b7.svg";